export const eng_text = {
  credential_disclaimer: "Maximum of two credentials per person",
  corresponsal_name: "Correspondent Name",
  id_disclaimer: "Name as it appears on ID",
  cameraman_name: "Cameraman name",
  email_cameraman: "Cameraman's email",
  email_correspondent: "Correspondent's email",
  email: "E-mail",
  platform_name: "Platform name",
  platform_website: "Platform Website",
  social_media: "Platform social networks",
  leave_blank: "leave blank if you don't have",
  how_many_credentials: "How many Credentials do you require?",
  people_credentials_name: "Name of the people for the credentials",
  people_credentials_name_help:
    "Separate names by commas. ex: Erik Sanchez, Mauricio James, etc",
  phone_number: "Phone number",
  phone_country_code: "Add country code",
  name: "Name...",
  email_placeholder: "E-Mail...",
  url: "URL...",
  thanks_for_submit: "Thanks for you participation, your info has been sent",
  close_page: "Now you can close this page",
};
